import React from 'react';

export interface PublicQuestionListSkeletonProps {
  count?: number;
}

function SkeletonRow(): React.ReactElement {
  return (
    <li
      className="fmp-browse-item fmp-browse-skeleton-item fmp-skeleton-item"
      aria-hidden="true"
    >
      <div className="fmp-browse-item__content">
        <div className="fmp-skeleton__title" />
        <div className="fmp-skeleton__description" />
        <div className="fmp-browse-item__meta">
          <div className="fmp-skeleton__meta" />
          <div className="fmp-skeleton__meta fmp-skeleton__meta--short" />
          <div className="fmp-skeleton__meta fmp-skeleton__meta--short" />
        </div>
      </div>
    </li>
  );
}

export function PublicQuestionListSkeleton({
  count = 5,
}: PublicQuestionListSkeletonProps): React.ReactElement {
  return (
    <div role="status" aria-busy="true" aria-label="Loading questions">
      <ul className="fmp-browse-list" role="list">
        {Array.from({ length: count }, (_, i) => (
          <SkeletonRow key={i} />
        ))}
      </ul>
      <span className="fmp-visually-hidden">Loading questions...</span>
    </div>
  );
}
